export const mutations = {
  addRole(state, role) {
    state.role = role
  },
  setRole(state, role) {
    state.role = role
  },
  addRoles(state, role) {
    state.roles = role
  },
  addRolesPage(state, role) {
    state.roles = role
  },
}
